// @ts-nocheck
import { Tooltip } from "@shared/antd/tooltip";
import { Typography } from "@shared/antd/typography";
import { Col } from "@shared/antd/col";
import { Row } from "@shared/antd/row";
import { Button } from "@shared/antd/button";
import { Modal } from "@shared/antd/modal";
import * as React from "react";
import {inject, observer} from "mobx-react";
import {collection, getCubaREST, injectMainStore, MainStoreInjected} from "@cuba-platform/react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {FormattedMessage, injectIntl, WrappedComponentProps} from "react-intl";
import {RootStoreProp} from "../../store";
import {action, observable} from "mobx";
import {UcoSignDocument} from "../../../cuba/entities/base/ucosign$Document";
import NcaLayer from "../../pages/DocumentSign/ncalayer";
import {UcoSignSignature} from "../../../cuba/entities/base/ucosign$Signature";
import {restServices} from "../../../cuba/services";
import Notification from "../../util/Notification/Notification";
import {downloadFile, goBackOrHomePage, parseUrlForUserCode} from "../../util/util";
import {collectionWithAfterLoad} from "../../util/DataCollectionStoreWithAfterLoad";
import DataTable from "../../components/DataTable/intex";
import {FileDescriptor} from "../../../cuba/entities/base/sys$FileDescriptor";
import QRCode from "react-qr-code";
import {getSignature} from "./document-signature.api";
import {PdfPreviewModal} from "../modal/ui/pdf-preview-modal";

type EditorProps = {
  entityId?: string;
  isActiveButtons?: boolean
  isNotiffqr?: boolean
  isSaving?: boolean
  isRedirect?: boolean
  documentInfo: any
  setDocumentInfo?: (value: any) => void
  status?: boolean
  isReloadingRow?: boolean
  statusSign?: boolean
  isNotDraft?: boolean
  isFull?: boolean
  requestStatus?: boolean
};

type State = {
  isLoadingDocument: boolean,
  isEdit: boolean
  previewFile: FileDescriptor | null
  setOpen: () => void | null
}

@injectMainStore
@inject("rootStore")
@observer
class DocumentSignatureNew extends React.Component<
  MainStoreInjected &
  WrappedComponentProps &
  RootStoreProp &
  EditorProps &
  RouteComponentProps,
  State
> {
  @observable
  idDocument: string

  @observable
  dataCollection = collection<UcoSignDocument>(UcoSignDocument.NAME, {
    filter: {
      conditions: [
        {
          property: "ucosignRegistration.id",
          operator: "=",
          value: this.idDocument || '1'
        }
      ]
    },
    view: "ucoSignDocument-buildDdc"
  });
  @observable
  selectedRowKey: string;

  state: State = {
    isLoadingDocument: false,
    isEdit: false,
    previewFile: null,
    setOpen: null
  };

  @observable
  ncLayerBtnDisabled: boolean = false;

  @observable
  ncLayerBtnLoading: boolean = false;

  @action
  setNcLayerBtnLoading = (value: boolean) => {
    this.ncLayerBtnLoading = value
  }

  @observable
  ncaLayer = new NcaLayer();

  @observable
  countNumber = 0;

  @observable
  countNumberParticipans = 0;

  @observable
  modalIsVisible = false;

  @observable
  imageData: any = null;

  @observable
  isDocumentSign = true;

  @action
  setIsDocumentSign = (value: boolean) => {
    this.isDocumentSign = value
  }

  @observable
  objectsCount = {};

  @observable
  objectsParticipansCount = {};

  @observable
  controller: AbortController;

  @observable
  approversForDocumentList: [];

  @observable
  isLoadApprovers = false

  @observable
  firstUpdate = true;

  @observable
  signature: UcoSignSignature[];


  @action
  setModalIsVisible = (bool: boolean) => {
    this.modalIsVisible = bool;
  };
  handleRowSelectionChange = (selectedRowKeys: string[]) => {
    this.selectedRowKey = selectedRowKeys[0];
    if (this.selectedRowKey) {
      this.isLoadApprovers = true;
      restServices.digitalSignatureSignService
        .getApproversForDocument({
          documentId: this.selectedRowKey
        })
        .then((value: any) => {
          value = JSON.parse(value);
          this.approversForDocumentList = value.approversForSignJsons;
        }).finally(() => {
        this.isLoadApprovers = false;
      });
    } else {
      if (this.dataCollection.items)
        this.selectedRowKey = this.dataCollection.items[0].id
      this.approversForDocumentList = [];
      this.countNumberParticipans = 0;
      this.objectsParticipansCount = {};
      this.isLoadApprovers = false;
    }
  };
  handleClickNCLayer = () => {
    const {isRedirect = true} = this.props
    this.ncaLayer.connect();
    this.ncLayerBtnLoading = true;
    this.isDocumentSign = false;
    let base64String: string;
    getCubaREST()!
      .getFile(this.dataCollection.items[0].originalFile!.id)
      .then(value => {
        const reader = new FileReader();
        reader.onload = () => {
          base64String = reader.result as string;
          base64String = base64String.split(",")[1];
          if (this.ncaLayer.getConnectionState() === "OPEN") {
            restServices.digitalSignatureSignService.getAvailabilitySign(
              {
                userId: this.props.rootStore!.userInfo!.id!,
                registrationId: this.idDocument || ''
              }
            ).then(async (val) => {
              if (val) {
                this.ncaLayer.createCMSSignatureFromBase64(
                  "PKCS12",
                  "SIGNATURE",
                  base64String,
                  false,
                  async value => {
                    if (value.code == 500) {
                      Notification.error({
                        message: this.props.intl.formatMessage({
                          id: `ucoSign_${value.message}`
                        })
                      });
                    } else if (value.code == 200) {
                      const controller = new AbortController();
                      const signal = controller.signal;

                      await restServices.ucoSign
                        .postFetch(
                          {
                            usDocumentId: this.selectedRowKey,
                            signUserId: this.props.rootStore!.userInfo!.id!,
                            signatureData: value.responseObject,
                          },
                          "add-signature",
                          signal
                        )
                        .then(value => {
                          if (!value.errorMessage) {
                            Notification.success({
                              message: this.props.intl.formatMessage({
                                id: `ucoSign_success`
                              })
                            });
                            this.isDocumentSign = true;
                            this.setState((prev) => ({
                              isLoadingDocument: !prev.isLoadingDocument
                            }));
                            isRedirect && goBackOrHomePage(this.props.history!);
                          } else {
                            let message = ""
                            try {
                              message = JSON.parse(value.error.cause.message).message
                            } catch (e) {
                              message = value.error.cause.message
                            }
                            Notification.error({message: message})
                          }
                        });
                    }
                    this.ncLayerBtnLoading = false;
                  }
                );
              } else {
                this.ncLayerBtnLoading = false;
                Notification.error({
                  message:
                    this.props.intl.formatMessage({
                      id: "documentSign.validate.order"
                    })
                })
              }
            })
          } else if (this.ncaLayer.getConnectionState() === "CLOSED") {
            setTimeout(() => {
              if (this.ncaLayer.getConnectionState() === "CONNECTING")
                this.handleClickNCLayer();
              else {
                this.ncLayerBtnLoading = false;
                return;
              }
            }, 200);
          }
        };
        reader.readAsDataURL(value);

      }).finally(() => setTimeout(() => {
      this.ncLayerBtnLoading = false
    }, 300));
  };

  handleClickQr = async () => {
    const {isNotiffqr = true, isRedirect = true} = this.props

    await restServices.digitalSignatureSignService.getAvailabilitySign(
      {
        userId: this.props.rootStore!.userInfo!.id!,
        registrationId: this.idDocument || ''
      }
    ).then(async (value) => {
      if (value) {
        try {
          let response = await restServices.ucoSign.getfetch(
            "description=Пакет документов на подписание",
            "get-qr-code"
          );
          this.imageData = {
            qrCode: parseUrlForUserCode(response.data),
            bin: response.data.eGovBusinessLaunchLink,
            iin: response.data.eGovMobileLaunchLink
          };

          this.modalIsVisible = true;
          isNotiffqr && Notification.info({
            message: this.props.intl.messages["documentSitn.info.qr"]
          });
          try {
            this.controller = new AbortController();
            const signal = this.controller.signal;
            await restServices.ucoSign
              .postFetch(
                {
                  dataURL: response.data.dataURL,
                  expiredAt: response.data.expireAt,
                  registrationIds: [this.idDocument]
                },
                "send-documents",
                signal
              )
              .then(() => {
                console.log('fetch') //todo loader
              });
            await restServices.ucoSign
              .postFetch(
                {
                  signURL: response.data.signURL,
                  expiredAt: response.data.expireAt,
                  signUserId: this.props.rootStore!.userInfo!.id!,
                  registrationIds: [this.idDocument]
                },
                "sign-documents",
                signal
              )
              .then(value => {
                if (!value.errorMessage) {
                  this.isDocumentSign = true;
                  restServices.reports.refreshBell({userId: this.props.rootStore!.userInfo.id || ''})
                  Notification.success({
                    message: this.props.intl.formatMessage({
                      id: `ucoSign_success`
                    })
                  });
                  this.setState((prev) => ({
                    isLoadingDocument: !prev.isLoadingDocument
                  }));
                  isRedirect && goBackOrHomePage(this.props.history!);
                } else {
                  let message = ""
                  try {
                    message = JSON.parse(value.error.cause.message).message
                  } catch (e) {
                    message = value.error.cause.message
                  }
                  Notification.error({message: message})
                }
                this.modalIsVisible = false;
              })
          } catch (error) {
          }
        } catch (error) {
        }
      } else {
        Notification.error({
          message:
            this.props.intl.formatMessage({
              id: "documentSign.validate.order"
            })
        })
      }
    })
  };
  fieldSignature = ["id", "originalFile", "finalFile"];

  changeNextCount(id: string): number {
    if (id in this.objectsCount) {
      return this.objectsCount[id];
    } else {
      this.objectsCount[id] = this.countNumber + 1;
      this.countNumber++;
      return this.objectsCount[id];
    }
  }

  render() {
    const {isActiveButtons = true, isFull = false} = this.props

    const handleOpen = (file: FileDescriptor) => {
      if (!this.state.setOpen) return

      this.setState({ previewFile: file })
      this.state.setOpen()
    }

    const renderMessage = () => {
      const {isNotDraft = true} = this.props
      if (!isNotDraft) {
        return this.state.isEdit
          ? <Typography.Text style={{color: 'red'}}>
            <FormattedMessage
              id={"ucoSignDocuments_documents_title"}

              defaultMessage={this.props.intl.formatMessage({
                id: "documentSitn.alertMessage"
              })}
            />
          </Typography.Text>
          : <Typography.Text style={{color: 'red'}}>
            <FormattedMessage
              id={"ucoSignDocuments_documents_title"}

              defaultMessage={this.props.intl.formatMessage({
                id: "documentSitn.alertMessage.save"
              })}
            />
          </Typography.Text>
      }
      return null
    }
    if (!this.signature) return <></>
    return (
      <div style={{marginBottom: '2rem'}}>
        <Row gutter={16}>
          <Col span={isFull === false ? 14 : undefined}>
            {
              //helper text
              renderMessage()
            }

            <style>
              {`
         
          .documentSign_id{
            width: 10%
          }
          .documentSign_originalFile{
            width: 45%
          }
          .documentSign_finalFile{
            width: 45%
          }
        `}
            </style>
            <DataTable
              enableFiltersOnColumns={[]}
              hideSelectionColumn
              dataCollection={this.dataCollection}
              fields={this.fieldSignature}
              onRowSelectionChange={this.handleRowSelectionChange}
              tableProps={{
                columns: [
                  {
                    className: 'documentSign_id',
                    title: this.props.intl.formatMessage({
                      id: "documentSign.number"
                    }),
                    align: 'center',
                    sorter: false,
                    render: (text, record) => {
                      if (this.firstUpdate)
                        this.componentDidUpdate(this.props, this.state)
                      return this.changeNextCount(record.id);
                    },
                  },
                  {
                    className: 'documentSign_originalFile',
                    key: "originalFile",
                    title: this.props.intl.formatMessage({
                      id: "documentSign.originalFile"
                    }),
                    align: 'center',
                    sorter: false,
                    render: (text, record) => {
                      const file = (record as UcoSignDocument).originalFile;
                      if (file)
                        return (
                          <a
                            onClick={() => handleOpen(file)}
                          >
                            {(file as FileDescriptor).name}
                          </a>
                        );
                      return <span/>;
                    },
                  },
                  {
                    className: 'documentSign_finalFile',
                    key: "finalFile",
                    title: this.props.intl.formatMessage({
                      id: "documentSign.finalFile"
                    }),
                    align: 'center',
                    sorter: false,
                    render: (text, record) => {
                      const file = (record as UcoSignDocument).finalFile;
                      if (file)
                        return (
                          <a
                            onClick={() => handleOpen(file)}
                          >
                            {(file as FileDescriptor).name}
                          </a>
                        );
                      return <span/>;
                    },
                  },
                ],
                pagination: false,
              }}
            ></DataTable>
          </Col>
        </Row>
        {isActiveButtons &&
          <div style={{marginTop: 15}}>
            <Button
              style={{marginRight: 15}}
              key="qrBtn"
              onClick={this.handleClickQr}
              loading={false}
              disabled={
                this.isDocumentSign
              }
            >
              {this.props.intl.formatMessage({id: "documentSign.btn.QR"})}
            </Button>
            <Tooltip
              placement="right"
              title={this.props.intl.formatMessage({id: 'documentSitn.ncLayer.hepler'})}>
              <Button
                style={{marginRight: 15}}
                key="nclayerBtn"
                loading={this.ncLayerBtnLoading}
                disabled={
                  this.ncLayerBtnDisabled ||
                  this.isDocumentSign
                  || !this.selectedRowKey
                }
                onClick={this.handleClickNCLayer}
              >
                {this.props.intl.formatMessage({
                  id: "documentSign.btn.NCLayer"
                })}
              </Button>
            </Tooltip>
          </div>
        }

        <Modal
          centered
          visible={this.modalIsVisible}
          onCancel={() => {
            this.setModalIsVisible(false);
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                this.setModalIsVisible(false);
                this.controller.abort();
              }}
            >
              {this.props.intl.formatMessage({
                id: "management.browser.exclude.cancel"
              })}
            </Button>
          ]}
        >
          <div>
            <Typography.Text style={{display: "block", marginBottom: '15px'}}>
              <span> {this.props.intl.formatMessage({id: "documentSitn.infoText.qr1"})}</span>
              <span
                style={{color: '#1ac404'}}> {this.props.intl.formatMessage({id: "documentSitn.infoText.qr2"})}</span>
            </Typography.Text>
            <div style={{height: "auto", margin: "0 auto", maxWidth: 256, width: "100%"}}>
              {this.signature[0] && this.signature[0].userSignType && this.imageData &&
                <QRCode
                  size={256}
                  style={{height: "auto", maxWidth: "100%", width: "100%"}}
                  value={`mobileSign:https://sigex.kz/api/egovQr/egov/${this.imageData.qrCode}`}
                  viewBox={`0 0 256 256`}

                />
              }
            </div>
          </div>
        </Modal>
        <PdfPreviewModal file={this.state.previewFile} setOpen={(open) => this.setState({ setOpen: open })} />
      </div>
    );
  }

  getRes = async (res: any) => {
    const {signature, isDocumentSign, idDocument} = await getSignature({
      result: res,
    });


    this.signature = signature;
    this.isDocumentSign = isDocumentSign;
    this.idDocument = idDocument
    if (idDocument) {
      this.setState((prev) => ({
        isLoadingDocument: true,
      }));
    }
  };

  componentDidMount() {
    this.getRes(this.props.documentInfo);
  }

  getSignStatus = async () => {
    const signature = this.signature || null
    const isSing = await  restServices.goalsProcessService.registrationIsSignedForUser({
      registrationId: this.idDocument,
      userId: this.props.rootStore.userInfo.id,
      isIin: this.props.requestStatus
    })

    this.props.setDocumentInfo({finalFile: isSing, signature})
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.statusSign !== this.props.statusSign) {
      this.setState({
        isEdit: this.props.statusSign || false
      })
    }

    const {isReloadingRow = true} = this.props

    if (this.firstUpdate && this.dataCollection.items[0]) {
      let selectedRow = [];
      selectedRow.push(this.dataCollection.items[0].id)
      this.firstUpdate = false;
    }
    if (this.props.documentInfo.ucoSignRegistrationId !== prevProps.documentInfo.ucoSignRegistrationId) {
      this.getRes(this.props.documentInfo)
    }
    if (this.props.entityId !== prevProps.entityId
      || this.state.isLoadingDocument !== prevState.isLoadingDocument
      || this.props.documentInfo.ucoSignRegistrationId !== prevProps.documentInfo.ucoSignRegistrationId
      || (prevProps.isSaving === true && this.props.isSaving === false)
    ) {
      if (prevProps.isSaving === true && this.props.isSaving === false) {
        this.getRes(this.props.documentInfo)
      }
      if (this.idDocument) {
        getCubaREST()!
          .searchEntities<UcoSignSignature>(
            UcoSignSignature.NAME,
            {
              conditions: [
                {
                  property: "signUser.id",
                  operator: "=",
                  value: this.props.rootStore!.userInfo!.id!
                },
                {
                  property: "ucosignDocument.ucosignRegistration.id",
                  operator: "=",
                  value: this.idDocument
                },
                {
                  property: "signDate",
                  operator: "=",
                  value: ""
                }
              ]
            },
            {view: "ucoSignSignature.edit", sort: "signOrder"}
          )
          .then(value => {
            this.signature = value as UcoSignSignature[];
            this.isDocumentSign =
              value.filter(val => val.signatureData == null).length == 0;
          });
      }
      if (this.idDocument) {
        this.dataCollection = collectionWithAfterLoad<UcoSignDocument>(UcoSignDocument.NAME, () => {
          this.objectsCount = {}
          this.countNumber = 0
          this.objectsParticipansCount = {}
          this.countNumberParticipans = 0;

          if (isReloadingRow && this.dataCollection.count <= 1) {
            this.selectedRowKey = this.dataCollection.items[0].id
          }
          this.getSignStatus()
        }, {
          filter: {
            conditions: [
              {
                property: "ucosignRegistration.id",
                operator: "=",
                value: this.idDocument
              }
            ]
          },
          view: "ucoSignDocument-buildDdc"
        });
        this.dataCollection.load();
      }
    }
  }
}


export const DocumentSignatureComponentNew = injectIntl(withRouter(DocumentSignatureNew));
